import address from "@/views/my/address.json";
import { checkPhone } from "@/utils/check";
import axios from "axios";

export default {
  data () {
    return {
      integralModalRules: {
        userAddress: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        userName: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        userRegion: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        userTel: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
      },
      integralModal: {
        show: false,
        order: {}, // 课程订单信息
        address: {}, // 地址信息
        form: {}, // 新增的收货地址
        onSuccess: () => {}, // 兑换成功
      },
      integralLoad: {
        buy: {}, // id: boolean
        form: false
      },
      addressList: [],
      addressOptions: address,
      addressStr: '',
      showIntegralPopover: false
    }
  },
  computed: {
    addressSelectValue: {
      get () {
        return (this.integralModal.form.userRegion || '').split(' ')
      },
      set (arr) {
        this.integralModal.form.userRegion = arr.join(' ')
      }
    }
  },
  methods: {
    getAddressList () {
      this.$post('/trading/shippingaddress/page', { page: 1, limit: 100 }).then(({ data }) => {
        this.addressList = data.list
        if (data.list.length) {
          const address = data.list[0]
          this.addressStr = address.id
          this.integralModal.address = {
            buyerName: address.userName,
            buyerTel: address.userTel,
            receiveAddress: address.allAddress
          }
        }
      })
    },
    onHideIntegralModal () {
      this.integralModal = {
        show: false,
        order: {},
        address: {},
        form: {}
      }
    },
    onIntegralConfirmForm () {
      this.$refs.modalForm.validate(valid => {
        if (!valid) return
        const req = this.integralModal.form
        if (!checkPhone(req.userTel)) {
          return this.$message.error('请输入合法的手机号')
        }
        this.integralLoad.form = true
        const isEdit = Reflect.has(req, 'id')
        axios[isEdit ? 'put' : 'post']('/trading/shippingaddress', req).then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error('操作失败')
          }
          this.getAddressList()
          this.showIntegralPopover = false
          this.integralModal.form = {}
        }).finally(() => {
          this.integralLoad.form = false
        })
      })
    },
    onExchangeIntegral (order, { onSuccess } = {}) {
      // 实体订单，并且还未提交
      if (!this.integralModal.show) {
        this.integralModal.show = true
        this.integralModal.order = order
        if (typeof onSuccess === 'function') {
          this.integralModal.onSuccess = onSuccess
        }
        this.getAddressList()
        return
      }
      if (this.integralModal.show && !this.addressStr) {
        // 验证收货地址
        return this.$message.error('请选择一个收货地址')
      }
      this.$set(this.integralLoad.buy, order.id, true)
      // 普通勋章和虚拟商品，直接兑换
      this.onBuy(Object.assign({}, this.integralModal.address, {
        goodsId: order.id,
        orderType: [null, 4, 1, 4][order.goodsType],
        userId: this.$store.state.user.id
      })).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('兑换成功')
        this.integralModal.onSuccess()
        this.onHideIntegralModal()
      }).finally(() => {
        this.integralLoad.buy[order.id] = false
        setTimeout(() => Reflect.deleteProperty(this.integralLoad.buy, order.id))
      })
    },
    /**
     * 积分兑换
     * 商品类型    订单类型
     * 课程 1  -  虚拟订单 4
     * 勋章3  -  虚拟订单 4
     * 实物商品2 - 实物订单1
     * @return {Promise | Promise<any>}
     */
    onBuy (query) {
      return this.$post('/trading/api/shoporder/order', query)
    },
  },
}
